// extracted by mini-css-extract-plugin
export default {"point":"style_point__pzT9c","svg":"style_svg__ehXHB"};